module.exports = __webpack_public_path__ + "img/Medical-06-512.54eac81b.png";